/**
 * ケース自身の需要 BG が対象日時点で失効している時 (AC-DFC-002a) の、需要想定
 * テーブル本体領域 (KomaGrid/KomaCard 領域) の案内表示。原因〈BG 失効〉と対処
 * 〈BG マスタで有効期間を確認〉を明示する catch-all でない文言 (spec 確定文言、
 * demand-forecast-common.md:74 @ 6ef7b00190)。BG 名・対象日は呼び出し元の
 * SectionHeader が維持するため、本 view は案内文言のみを表示する。
 *
 * design HTML には BG 失効専用の空状態 surface が無い (Design gap)。既存
 * AreaNotSetView と同型の空状態パターン (Flex 中央寄せ + Text) を流用する。
 */
import { useTranslation } from 'react-i18next'

import { Flex, Text } from '@enechain/ecloud-designsystem'

type Props = {
  /** 当該ケースの対象日 (YYYY/MM/DD)。spec 文言テンプレートへ埋め込む。 */
  targetDateLabel: string
}

export const BgExpiredNoticeView = ({
  targetDateLabel,
}: Props): React.ReactElement => {
  const { t } = useTranslation()
  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      gap={4}
      height="300px"
      paddingX={4}
    >
      <Text color="Text.midEmphasis" fontSize="sm">
        {t('page:demandForecastDaily.error.bgExpired', {
          targetDate: targetDateLabel,
        })}
      </Text>
    </Flex>
  )
}
